<div id="content-menu" fxLayout="row" fxLayoutAlign="space-around center" *ngIf="!diviceXs && !diviceSm && !menuMobile">
    <ul>
        <li id="btn-Categorias">

            <span>
                <i class="material-icons">menu</i>
                Productos
            </span>

            <ul id="mainProductsMenu">
                <span class="triangle"></span>
                <li *ngFor="let itemsMenu of listMenu" class="itemsMainProducts">

                    {{itemsMenu.itemFather}}

                    <ng-container *ngIf="itemsMenu.itemsChildren">
                        <div class="subMenu">
                            <div *ngFor="let itemsSubMenu of itemsMenu.itemsChildren" class="itemsSubMenu">

                                <h2>{{itemsSubMenu.title}}</h2>

                                <ul>
                                    <ng-container *ngFor="let subMenuItems of itemsSubMenu.itemInChildren">
                                        <!-- <a [href]="subMenuItems.url"> -->

                                        <a [routerLink]="[{outlets: { primary: ['products', subMenuItems.url], sidebar: ['products', subMenuItems.url]}}]">
                                            <li>{{subMenuItems.itemName}}</li>
                                        </a>
                                    </ng-container>
                                </ul>
                            </div>
                        </div>
                    </ng-container>
                </li>
            </ul>
        </li>
    </ul>

    <ul>
        <li id="btn-property">
            <span>Bienes</span>

            <ul id="mainPropertyMenu">
                <span class="triangle"></span>
                <!-- <a *ngFor="let itemsBienes of listBienes" class="itemsMainProducts"
                    [routerLink]="['/','products',itemsBienes.url]">
                    <li>{{itemsBienes.itemName}}</li>
                </a> -->
                <a *ngFor="let itemsBienes of listBienes" class="itemsMainProducts" [routerLink]="[{ outlets: { primary: ['products'], sidebar: ['products']}}]">
                    <li>{{itemsBienes.itemName}}</li>
                </a>
            </ul>

        </li>
    </ul>

    <ul>
        <li id="btn-property">
            <span>Servicios</span>
        </li>
    </ul>

</div>

<div id="cellMenu" *ngIf="diviceXs || diviceSm && !menuMobile">
    <button mat-stroked-button color="primary" (click)="toggleRightSidenav()">
        <i class="material-icons md-24">menu</i>
    </button>
</div>


<mat-accordion id="menuMobile" *ngIf="menuMobile">
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'" class="disable_ripple">
            <mat-panel-title>
                <h2>Productos</h2>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-accordion>
            <mat-expansion-panel *ngFor="let itemsMenu of listMenu">
                <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'">
                    <mat-panel-title>
                        <h3>{{itemsMenu.itemFather}}</h3>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ng-container *ngIf="itemsMenu.itemsChildren">
                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let itemsSubMenu of itemsMenu.itemsChildren">
                            <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'">
                                <mat-panel-title>
                                    <h4>{{itemsSubMenu.title}}</h4>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <ul>
                                <ng-container *ngFor="let subMenuItems of itemsSubMenu.itemInChildren">
                                    <!-- <a [href]="subMenuItems.url"> -->
                                    <a (click)="closeSlidenNav()" [routerLink]="[{ outlets: { primary: ['products', subMenuItems.url], sidebar: ['products', subMenuItems.url]}}]">
                                        <li>{{subMenuItems.itemName}}</li>
                                    </a>
                                </ng-container>
                            </ul>
                        </mat-expansion-panel>
                    </mat-accordion>
                </ng-container>

            </mat-expansion-panel>
        </mat-accordion>
    </mat-expansion-panel>

    <mat-expansion-panel>
        <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'">
            <mat-panel-title>
                <h2>Bienes</h2>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <ul id="mainPropertyMenu">
            <span class="triangle"></span>
            <!-- <a *ngFor="let itemsBienes of listBienes" class="itemsMainProducts"
                [routerLink]="['/','products',itemsBienes.url]">
                <li>{{itemsBienes.itemName}}</li>
            </a> -->

            <a *ngFor="let itemsBienes of listBienes" class="itemsMainProducts" [routerLink]="[{ outlets: { primary: ['products'], sidebar: ['products']}}]">
                <li>{{itemsBienes.itemName}}</li>
            </a>
        </ul>

    </mat-expansion-panel>

    <mat-expansion-panel>
        <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'">
            <mat-panel-title>
                <h2>Servicios</h2>
            </mat-panel-title>
        </mat-expansion-panel-header>

    </mat-expansion-panel>

</mat-accordion>